<h4>Meine Bestellungen</h4>
<div *ngIf="myorders$ | async as orders">
  <div *ngFor="let order of orders">
    <div class="clickable" (click)="showOrder(order)">
      <span>{{ order.id }}</span
      ><span> {{ order.created_at | date: 'dd.MM.yyyy HH:mm' }}</span>
      <span> {{ order.totalPrice.getAmountGross() | number: '1.2' }} €</span

      ><span> {{ readablePaymentMethod(order['payment_method']) }}</span>
      <span>{{readableStatus(order.status)}}</span>
    </div>
    <ui-order-detail
      [class.show]="order.id == showOrderId"
      [order]="orderToShow"
      [orderDTO]="orderDTOToShow"
    ></ui-order-detail>
  </div>
</div>
